import { render, staticRenderFns } from "./OrderTotalAmount.vue?vue&type=template&id=e1fe6764&scoped=true"
import script from "./OrderTotalAmount.vue?vue&type=script&lang=js"
export * from "./OrderTotalAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1fe6764",
  null
  
)

export default component.exports